"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});

var _Tabs = _interopRequireDefault(require("./Tabs"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Tabs/index.js
 ** module id = 769
 ** module chunks = 0
 **/